<template>
    <el-menu
        :default-active="defaultAct"
        class="sideBar"
        @select="menuSelected"
        text-color="#414A60"
        unique-opened
        active-text-color="#155BD4">
        <nav-menu :navMenus="leftMenus"></nav-menu>
    </el-menu>
</template>
 
<script>
import navMenu from "./navMenu";
import storage from "@/utils/storage";
import {mapState} from 'vuex';

import './comps.less'
export default {
    name:'sideBar',
    data() {
        let navsList = storage.getItem("navs",1);
        return {
            defaultAct: "",
            curUrl: "",
            leftMenus: (navsList && navsList.childList) || [],
            defaultOpeneds: [],
            needUpdate: false
        };
    },
    created() {
       
    },
    mounted() {
        let me = this;
        this.getCurRealSelect(this.$route.path, "url");
        // 切换公司成功后，需要更新当前菜单的选中项
        this.$bus.on("updateNavMenu", function() {
            const navs = storage.getItem("navs",1)
            if(navs && navs.childList && navs.childList.length ){
                me.defaultAct = navs.childList[0].id
            }
        });
        const navs = storage.getItem("navs",1)
        if (!this.leftMenus || !this.leftMenus.length) {
            if(navs.length == 0){
                this.leftMenus = navs.childList;
                this.defaultOpeneds = this.getDefaultOpen();
                this.getCurRealSelect(this.leftMenus[0].id);
                return
            } 
            requestDat.get({
                url: "/getCurrentResource"
            })
            .then(res => {
                this.leftMenus = res.childList;
                this.defaultOpeneds = this.getDefaultOpen();
                this.getCurRealSelect(this.leftMenus[0].id);
                storage.setItem("navs", res,1);
            });
        } else {
            this.getCurRealSelect(this.$route.path, "url");
            this.defaultOpeneds = this.getDefaultOpen();
        }
    },
    components: {
        navMenu
    },
    methods: {
        onUpgradeClick() {
            this.$emit("upgradeclick");
        },
        getDefaultOpen() {
            let arr = [];
            if(this.leftMenus && this.leftMenus.length){
                this.leftMenus.forEach(l => {
                    arr.push(l.id);
                });
            }
            return arr;
        },
        menuSelected(index, indexPath, vueM, type) {
            const toName = vueM.$attrs.data.keyName
            const currentName = vueM.$route.name
            if(toName == currentName) return


            if (vueM && vueM.$attrs && vueM.$attrs.data && vueM.$attrs.data.name) {
                storage.setItem('navMenuName',vueM.$attrs.data.name)
            }
            let me = this;
            // 在编辑/查看（因为这两个需要id，从其他页面回来时，是没有id的），状态的这两个页面不能直接跳到其他页面，必须手动退出
            // if (["/agentList/editAgent","/customerList/editCustomer"].indexOf(this.$route.path)>-1 && this.$route.query.type != 'add' ) {
            //     alert('当前页面属于编辑页面，请点击 X 关闭或者点击【返回】按钮')
            //     let defaultAct = this.defaultAct;
            //     this.defaultAct = "";
            //     setTimeout(() => {
            //         me.defaultAct = defaultAct;
            //     });
            //     return false;
            // }
            this.getCurRealSelect(index);
            if (this.$route.path !== this.curUrl) {
                this.$router.push(this.curUrl);
            }
        },
        getCurRealSelect(val, key) {
            this.defaultAct = "";
            this.curUrl = "";
            this.getCurSelect(this.leftMenus, val, key);
        },
        getCurSelect(arr, val, key) {
            for (let i = 0; i < arr.length; i++) {
                const element = arr[i];
                if (key) {
                    if (element[key] && val.indexOf(element[key]) > -1) {
                        this.defaultAct = element.id;
                        return false
                    }
                } else {
                    if (element.id === val) {
                        this.defaultAct = val;
                        this.curUrl = element.url;
                        return false
                    }
                }
                if (element.childList && element.childList.length) {
                    this.getCurSelect(element.childList, val, key);
                }
            }
            
        }
    },
    watch: {
        "$route.path": function(nval, oval) {
            if (nval && oval && nval !== "/home") {
                this.getCurRealSelect(nval === "/home" ? "" : nval, "url");
            }
        }
    },
    computed: {
        ...mapState({
            isPass: function(state){
                return state.app.isPass
            },
        })
    },
};
</script>


// WEBPACK FOOTER //
// src/pages/layout/comps/sideBar.vue